import { Pipe, PipeTransform } from '@angular/core';
import { DurationUtils } from '@app/shared/services/duration-utils';
import { Duration } from 'luxon';

/**
 * Limited to hours as the largest time unit to ensure that
 * values are accurate over leap years, month-day diffences,
 * and DST changes.
 */
@Pipe({
    name: 'humanDuration',
    standalone: true
})
export class HumanDurationPipe implements PipeTransform {
    transform(value: number | Duration, maxSignificantUnits = 2): string {
        return DurationUtils.toHumanDuration(value, maxSignificantUnits);
    }
}
